import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "./Logo";

export const Header = () => {
  const { scrollY } = useScroll();
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useMotionValueEvent(scrollY, "change", (latest) => {
    setScrolled(latest > 20);
  });

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 z-50 w-full transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#0A0A0A]/70 border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
      data-testid="landing-header"
    >
      <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between">
        <Logo className="text-2xl" />

        <div className="flex items-center gap-3 sm:gap-5">
          <button
            data-testid="sign-in-btn"
            onClick={() => navigate("/login")}
            className="hidden sm:inline-flex text-sm font-semibold text-zinc-300 hover:text-white transition-colors duration-300 px-3 py-2"
          >
            Sign In
          </button>
          <button
            data-testid="header-google-btn"
            onClick={() => navigate("/login")}
            className="inline-flex items-center gap-2.5 rounded-full bg-white text-black text-sm font-semibold pl-3.5 pr-5 py-2.5 hover:bg-zinc-200 transition-colors duration-300"
          >
            <GoogleIcon />
            <span className="hidden xs:inline sm:inline">Sign in with Google</span>
            <span className="inline xs:hidden sm:hidden">Sign in</span>
          </button>
        </div>
      </div>
    </motion.header>
  );
};

export const GoogleIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
    <path
      fill="#FFC107"
      d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"
    />
    <path
      fill="#FF3D00"
      d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"
    />
    <path
      fill="#4CAF50"
      d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0124 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"
    />
    <path
      fill="#1976D2"
      d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 01-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"
    />
  </svg>
);
